import { addDisplayName, addProps, addStateHandlers, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'
import { addExtendedHandlers } from 'ad-hok-utils'
import { trackEvent } from 'shared/src/utils/analytics'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { SearchModal } from './SearchModal'
import searchIcon from '../../assets/backgroundless-search-icon.svg'

const useStyles = createUseStyles({
  searchButton: {
    background: 'none',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    width: 44,
    height: 44,
    padding: 0,
  },
})

interface Props {
  className?: string
}

export const SearchButton: FC<Props> = flowMax(
  addDisplayName('SearchButton'),
  addStateHandlers(
    {
      isSearchModalOpen: false,
    },
    {
      onOpenSearchModal: () => () => ({
        isSearchModalOpen: true,
      }),
      onCloseSearchModal: () => () => ({
        isSearchModalOpen: false,
      }),
    }
  ),
  addExtendedHandlers({
    onOpenSearchModal: () => () => {
      trackEvent({
        category: 'general',
        action: 'search',
      })
    },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({
    isSearchModalOpen,
    onOpenSearchModal,
    onCloseSearchModal,
    classes,
    className,
    t,
  }) => (
    <>
      <button
        onClick={onOpenSearchModal}
        className={cx(classes.searchButton, className)}
      >
        <img src={searchIcon} alt={t('menu.searchAlt')} />
      </button>
      {isSearchModalOpen && <SearchModal onClose={onCloseSearchModal} />}
    </>
  )
)
